import { graphql } from "~/gql";

export const FILTER_EXTERNAL_MATTERS = graphql(/* GraphQL */ `
  query FilterExternalMatters($input: FilteredExternalMattersInput!) {
    filteredExternalMatters(input: $input) {
      externalMatters {
        ...ExternalMatterParts
      }
      total
    }
  }
`);
